import React, { FC } from 'react';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';

const REPORT_ITEMS = [
  { label: 'General', path: '/admin/reports/general' },
  { label: 'CLE', path: '/admin/reports/cle' },
] as const;

const ReportsPanel: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="NavPanel-body ReportsPanel" role="list">
      <div className="NavPanel-list">
        {REPORT_ITEMS.map((item) => {
          const isActive = pathname === item.path;

          return (
            <div
              key={item.path}
              className={classNames('NavPanel-item', {
                'NavPanel-item--active': isActive,
              })}
              role="listitem"
              onClick={() => navigate(item.path)}
            >
              <span className="NavPanel-item-text">{item.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(ReportsPanel);
